<template>
  <div class="container-fluid">
    <Breadcrumbs main="Рейтинг" title="Мировой рейтинг" />
    <b-card>
      <RatingTab v-if="tabList.length" :data="tabList" />
      <header class="d-flex justify-content-between mt-3">
        <SearchRating class="w-25" />
        <Actualize :actualize-function="actualizeRating" />
      </header>

      <!-- 🌀 Лоаддер -->
      <div class="d-flex justify-content-center mt-4" v-if="isLoading">
        <b-spinner label="Loading..." variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
      </div>

      <!-- 📋 Таблица -->
      <div v-else class="d-flex mt-3">
        <b-table :items="teamsWorldRatingList" :fields="teamsWorldRatingFields" />
      </div>

      <PaginationRating :total="paginationTotal" class="mt-3 mb-3" />
    </b-card>
  </div>
</template>

<script>
import api from "@/api/api";
import SearchRating from "@/pages/Rating/components/SearchRating.vue";
import PaginationRating from "@/pages/Rating/components/PaginationRating.vue";
import RatingTab from "@/pages/Rating/components/RatingTab.vue";
import Actualize from "@/pages/Rating/components/Actualize.vue";

export default {
  components: {
    RatingTab,
    SearchRating,
    PaginationRating,
    Actualize,
  },
  data() {
    return {
      tabList: [],
      teamsWorldRatingList: [],
      teamsWorldRatingFields: [
        { key: 'id', label: 'ID' },
        { key: 'place', label: 'Место' },
        { key: 'name', label: 'Название' },
        { key: 'rating', label: 'Рейтинг' },
        { key: 'country', label: 'Код страны' }
      ],
      paginationTotal: 0,
      isLoading: false, // <-- добавили
    };
  },
  watch: {
    "$route"(newRoute) {
      if (newRoute.params.region) {
        this.handleQueryChange();
      }
    },
  },
  methods: {
    async actualizeRating() {
      try {
        await api.worldTeamRating.actualize();
        console.log("Актуализация завершена");
      } catch (error) {
        console.error("Ошибка актуализации:", error);
      }
    },

    async handleQueryChange() {
      const queryParams = {
        region: this.$route.params.region,
        page: parseInt(this.$route.query.page) || 1,
      };
      if (this.$route.query.search) {
        queryParams['filter[team.name]'] = this.$route.query.search;
      }
      this.fetchTeamsWorldRating(queryParams);
    },

    formatData(data) {
      return Object.entries(data).map(([key, value]) => ({
        id: key,
        name: value,
        slug: key,
      }));
    },

    async fetchTeamsWorldRatingRegions() {
      try {
        const res = await api.worldTeamRating.regions();
        this.tabList = this.formatData(res.data.data);
      } catch (error) {
        console.error("Error fetching world rating regions:", error);
      }
    },

    async fetchTeamsWorldRating(queryParams = {}) {
      this.isLoading = true; // <-- Показать лоаддер
      try {
        this.teamsWorldRatingList = [];
        const { region, ...params } = queryParams;
        const res = await api.worldTeamRating.index(region, params);
        this.paginationTotal = Math.ceil(res.data.pagination.total / res.data.pagination.by);
        this.teamsWorldRatingList = res.data.data.map(team => ({
          id: team.id,
          place: team.place,
          name: team.name,
          rating: team.rating,
          country: team.country.code,
        }));
      } catch (error) {
        console.error("Error fetching world rating:", error);
      } finally {
        this.isLoading = false; // <-- Скрыть лоаддер
      }
    },
  },
  created() {
    if (this.$route.params.region) {
      const queryParams = {
        region: this.$route.params.region,
        page: parseInt(this.$route.query.page) || 1,
      };
      this.fetchTeamsWorldRatingRegions();
      this.fetchTeamsWorldRating(queryParams);
    } else {
      this.$router.replace({
        name: 'world-rating-info',
        params: { region: 'cis' },
        query: this.$route.query,
      });
    }
  }
};
</script>
